export default __webpack_public_path__ + "static/media/Masters1-1024x1024.a5ad74a3.png";